<template>
  <div class="rootDiv">
    <a-upload-dragger
      v-if="inputType === 'table2d'"
      ref="myFile"
      accept=".xlsx,.csv,.xls,.txt"
      action=""
      :beforeUpload="() => false"
      @change="handleChange"
      class="upload-button"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <h3 class="ant-upload-text">上传文件（点击，或将文件拖拽到此处）</h3>
    </a-upload-dragger>
    <a-tabs
      :activeKey="activeKey"
      @change="changeTab"
      type="line"
      :tabBarStyle="{ marginBottom: 0 }"
      ref="tab"
      size="large"
      v-if="params.length"
    >
      <a-tab-pane key="1" class="white aTab" tab="参数填写（输入框形式）">
        <a-form-model :rules="rules" :model="parsedParams" ref="paramsForm">
          <a-row :gutter="48">
            <a-col v-for="i in params" :key="i.name" :span="12">
              <a-form-model-item :prop="i.name">
                <template slot="label">
                  <span>
                    {{ i.name }}
                    <a-tooltip v-if="i.explain">
                      <template slot="title"> {{ i.explain }}</template>
                      <a-icon type="question-circle" theme="twoTone" />
                    </a-tooltip>
                  </span>
                </template>
                <a-input
                  v-model="parsedParams[i.name]"
                  v-if="['list', 'str'].indexOf(i.form_type.type) != -1"
                />
                <a-input-number
                  v-model="parsedParams[i.name]"
                  v-if="['int', 'float'].indexOf(i.form_type.type) != -1"
                  style="width: 100%"
                />
                <a-select
                  v-model="parsedParams[i.name]"
                  v-if="i.form_type.type === 'select'"
                >
                  <a-select-option
                    v-for="j in i.form_type.options"
                    :key="j"
                    :value="j"
                    >{{ j }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-tab-pane>
      <a-tab-pane
        key="2"
        force-render
        style="font-size: 2rem"
        class="white aTab"
        tab="参数填写（json形式）"
      >
        <!-- <template v-slot:tab>
          <h2 class="tab-head">json格式</h2>
        </template> -->
        <a-textarea
          type="text"
          v-model="paramsStr"
          :autoSize="{ minRows: 4, maxRows: 10 }"
          style="font-size: 1.2rem"
        ></a-textarea>
      </a-tab-pane>
    </a-tabs>
    <a-row class="white" type="flex" justify="end">
      <a-col>
        <a-button
          type="primary"
          class="button"
          @click="commit"
          ref="commitButton"
          :disabled="!buttonable"
        >
          <span><a-icon type="loading" v-if="!buttonable" /></span>
          {{ buttonText }}
          <span v-if="!buttonable">中</span>
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      parsedParams: {},
      paramsStr: '',
      activeKey: '1',
      rules: {},
      floatParams: [],
      intParams: [],
      file: null
    }
  },
  props: {
    params: Array,
    inputType: String,
    buttonText: String,
    buttonable: Boolean
  },
  created() {
    const rules = {}
    const parsedParams = {}
    for (const p of this.params) {
      const ft = p.form_type
      if (p.required !== undefined && p.required === false) {
        rules[p.name] = []
      } else {
        rules[p.name] = [
          { required: true, trigger: 'blur', message: '请填写' }
        ]
      }
      if (ft.type === 'int' || ft.type === 'float') {
        if (ft.max !== undefined) {
          rules[p.name].push({
            max: ft.max,
            trigger: 'blur',
            massage: '最大为:' + ft.max
          })
        }
        if (ft.min !== undefined) {
          rules[p.name].push({
            max: ft.min,
            trigger: 'blur',
            massage: '最小为:' + ft.min
          })
        }
      }
      parsedParams[p.name] = p.default_value
      if (p.form_type.type === 'int') {
        this.intParams.push(p.name)
      }
      if (p.form_type.type === 'float') {
        this.floatParams.push(p.name)
      }
    }
    this.rules = rules
    this.parsedParams = parsedParams
  },
  methods: {
    async changeTab(key) {
      if (key === '2') {
        this.paramsStr = JSON.stringify(this.parsedParams, null, 4)
        this.activeKey = '2'
      } else {
        try {
          this.parsedParams = JSON.parse(this.paramsStr)
          // 将number类型的变量进行转换
          this.str2number()
          this.activeKey = '1'
        } catch (error) {
          this.$message.error('json字符串格式错误')
        }
      }
    },
    reset() {},
    async commit() {
      this.buttonable = false
      // 检查是否选择了文件
      if (!this.file) {
        this.$message.error('请选择文件')
        this.buttonable = true
        return ''
      }
      // 检查json字符串是否合法
      if (this.activeKey === '2') {
        try {
          this.parsedParams = JSON.parse(this.paramsStr)
        } catch (error) {
          this.$message.error('json字符串格式错误')
          this.buttonable = true
          return ''
        }
      }
      this.str2number()
      await this.$nextTick()
      // 表单验证
      if (this.params.length) {
        try {
          await this.$refs.paramsForm.validate()
        } catch (err) {
          this.$message.error('请填写正确的参数')
          this.activeKey = '1'
          this.buttonable = true
          return ''
        }
      }
      // 开始发送请求
      const formData = new FormData()
      formData.append('params_str', JSON.stringify(this.parsedParams))
      formData.append('file', this.file)
      this.$emit('commit', formData)
    },
    handleChange(info) {
      this.file = info.fileList[0] ? info.fileList[0].originFileObj : null
    },
    str2number() {
      for (const p of this.intParams) {
        this.parsedParams[p] =
          this.parsedParams[p] === ''
            ? this.parsedParams[p]
            : parseInt(this.parsedParams[p])
      }
      for (const p of this.floatParams) {
        this.parsedParams[p] =
          this.parsedParams[p] === ''
            ? this.parsedParams[p]
            : parseFloat(this.parsedParams[p])
      }
    }
  }
}
</script>

<style scoped>
.rootDiv {
  margin: 0rem 2rem 1rem 2rem;
}
.white {
  background-color: white;
}
.aTab {
  padding: 2rem 3rem 1rem 3rem;
}
.button {
  margin: 1rem 2rem 2rem 0;
  float: right;
}
.upload-button {
  margin-bottom: 1rem;
  /* margin: 0 3rem 1rem 3rem; */
}
.tab-head {
  margin: 0.2rem 1rem 0.2rem 1rem;
}
</style>
